import { FormControl, Grid, InputAdornment, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomInputLabel,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  CustomTextFeildforFamily,
  StyledDateContainer,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import styles from "../reportSection.module.scss";
import { ValidationError, object, string } from "yup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { PoojaTypeListProps } from "../../../infrastructure/GlobalContextProvider";
import { apiRequest } from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import { CustomRadioButton } from "../../common/StyledComponents/StyledFields";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";

interface ErrorMessageTypesReport {
  signInName: string;
  pooja: string;
  receiptdateFrom: string;
  receiptdateTo: string;
  poojadateFrom: string;
  poojadateTo: string;
  location: string;
}
const formFieldsPoojaBookingReport = {
  signInName: "",
  pooja: "",
  receiptdateFrom: dayjs().subtract(7, 'day').format("MM/DD/YYYY"),
  receiptdateTo: dayjs().format("MM/DD/YYYY"),
  poojadateFrom: dayjs().subtract(7, 'day').format("MM/DD/YYYY"),
  poojadateTo: dayjs().format("MM/DD/YYYY"),
  location: "",
};

const PoojaBookingReport = ({ sendDataToParent, getReportData }: any) => {
  const [errorMessageBookPoojaReport, setErrorMessageBookPoojaReport] =
    useState<ErrorMessageTypesReport>({ ...formFieldsPoojaBookingReport });
  const [formDataBookPoojaReport, setFormDataBookPoojaReport] = useState(
    formFieldsPoojaBookingReport
  );
  const [poojaItemsList, setPoojaItemsList] = useState<PoojaTypeListProps[]>(
    []
  );
  const [selectedPoojaId, setSelectedPoojaId] = useState<number | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  const validationSchemaForpoojaReport = object().shape({
    signInName: string().required("SignIn-Name is required"),
    receiptdateFrom: string().required("Receipt Date From is required"),
    receiptdateTo: string().required("Receipt Date TO is required"),
    poojadateFrom: string().required("Pooja Date From is required"),
    poojadateTo: string().required("Pooja Date To is required"),
    pooja: string().required("Pooja is required"),
    location: string().required("Location is required"),
  });

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.poojaTypeByPoojaLocation,
      params: {
        poojaType: formDataBookPoojaReport.location,
      },
      includeToken: true,
    })
      .then((res) => {
        setPoojaItemsList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [formDataBookPoojaReport.location]);

  const getPoojaBookingReports = () => {
    let location = "";
    if (formFieldsPoojaBookingReport.location === "TEMPLE_POOJA") {
      location = "Temple";
    } else if (formFieldsPoojaBookingReport.location === "OUTSIDE_POOJA") {
      location = "Outside";
    }
    const reqBody = {
      ...(formDataBookPoojaReport.signInName && { signInName: formDataBookPoojaReport.signInName }),
      ...(formDataBookPoojaReport.pooja && { poojaId: selectedPoojaId }),
      ...(formDataBookPoojaReport.poojadateFrom && { poojaFromDate: formDataBookPoojaReport.poojadateFrom }),
      ...(formDataBookPoojaReport.poojadateTo && { poojaToDate: formDataBookPoojaReport.poojadateTo }),
      ...(formDataBookPoojaReport.receiptdateFrom && { receiptFromDate: formDataBookPoojaReport.receiptdateFrom }),
      ...(formDataBookPoojaReport.receiptdateTo && { receiptToDate: formDataBookPoojaReport.receiptdateTo }),
      ...(formDataBookPoojaReport.location && { location: location }),
      pageNumber: 1,
      pageSize: 10
      
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/pooja/POOJA_BOOKING_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        // getReportData(res.data);
        const totalAmounts = res.data[0].data.pop();
        sendDataToParent(true, {reqBody,totalAmounts});
        const response = res.data[0].data.map((report:any)=>{
          return {
            "Receipt No.":report.receiptnumber,
            "Reference No.":report.id,
            "Receipt Date":report.dateofpoojabooking,
            "Mode of Payment":report.modeofpayment,
            "Check Number/Account Holder Name":report.checknumber,
            "Date of transaction":report.transactiondate,
            "Devotee Name(Sign-in Name)":`${report.firstname} ${report.lastname} (${report.username})`,
            "Pooja Name":report.poojaname,
            "Priest Name(Sign-in Name)":report.priest,
            "Pooja Date":report.poojadate,
            "Priest Selected By(Sign-in Name)":report.priest_selectedby || "--",
            "Donation Amount":formatAmount(report.amount),
            "Refund Amount":formatAmount(report.refundamount),
            "Refund Date":report.refunddate,
            "Refund Reason":report.reasonforrefund,
            "Refund Check Number":report.refund_checknumber,
        }
          })
          getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmitBookReport = async () => {
    const errors: ErrorMessageTypesReport = {
      ...formFieldsPoojaBookingReport,
    };
    try {
      // Validate the form data against the validation schema
      // await validationSchemaForpoojaReport.validate(formDataBookPoojaReport, {
      //   abortEarly: false,
      // });
      // If validation passes, you can submit the form
      // setErrorMessageBookPoojaReport(errors);
      // Call your API or perform other actions here
      getPoojaBookingReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesReport] = e.message;
          }
        });
      }
      setErrorMessageBookPoojaReport(errors);
    }
  };

  const handleDropdownChange = (field: any, value: any) => {
    if (
      field === "poojadateFrom" ||
      field === "poojadateTo" ||
      field === "receiptdateFrom" ||
      field === "receiptdateTo"
    ) {
      const formattedDate = dayjs(value, "MM/DD/YYYY");

      setFormDataBookPoojaReport({
        ...formDataBookPoojaReport,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else {
      setFormDataBookPoojaReport({
        ...formDataBookPoojaReport,
        [field]: value,
      });
    }
    if (field === "pooja") {
      const selectedPooja = poojaItemsList.find(
        (item: PoojaTypeListProps) => item.name === value
      );
      setSelectedPoojaId(selectedPooja?.id);
      // getDeitiesListByPoojaId(selectedPooja?.id);
    }
    switch(field) {
      case "location" :
        formDataBookPoojaReport.location = value;
        break;
      default :
       break; 
    }
  };

  const PoojaListDropdownDaily = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataBookPoojaReport.pooja}
            onChange={(e) => {
              handleDropdownChange("pooja", e.target.value);
              setErrorMessageBookPoojaReport({
                ...errorMessageBookPoojaReport,
                pooja: "",
              });
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
            className={styles.dateFeildforfamily
            }
          >
            {poojaItemsList.map((item: any, i: any) => (
              <CustomMenuItem value={item.name} key={i}>
                {item.name}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
        {errorMessageBookPoojaReport.pooja ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessageBookPoojaReport.pooja}
          </Typography>
        ) : (
          ""
        )}
      </>
    );
  };

  const ReceiptDobDatePickerTo = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataBookPoojaReport.receiptdateTo
                    ? dayjs(formDataBookPoojaReport.receiptdateTo, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleDropdownChange("receiptdateTo", value);
                  setErrorMessageBookPoojaReport({
                    ...errorMessageBookPoojaReport,
                    receiptdateTo: "",
                  });
                }}
                className={styles.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const PoojaDobDatePickerTo = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataBookPoojaReport.poojadateTo
                    ? dayjs(formDataBookPoojaReport.poojadateTo, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleDropdownChange("poojadateTo", value);
                  setErrorMessageBookPoojaReport({
                    ...errorMessageBookPoojaReport,
                    poojadateTo: "",
                  });
                }}
                className={styles.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const ReceiptDobDatePickerFrom = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataBookPoojaReport.receiptdateFrom
                    ? dayjs(
                        formDataBookPoojaReport.receiptdateFrom,
                        "MM-DD-YYYY"
                      )
                    : ""
                }
                onChange={(value) => {
                  handleDropdownChange("receiptdateFrom", value);
                  setErrorMessageBookPoojaReport({
                    ...errorMessageBookPoojaReport,
                    receiptdateFrom: "",
                  });
                }}
                className={styles.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const PoojaDobDatePickerFrom = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataBookPoojaReport.poojadateFrom
                    ? dayjs(formDataBookPoojaReport.poojadateFrom, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleDropdownChange("poojadateFrom", value);
                  setErrorMessageBookPoojaReport({
                    ...errorMessageBookPoojaReport,
                    poojadateFrom: "",
                  });
                }}
                className={styles.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };
 
  const handleClear = () => {
    setFormDataBookPoojaReport({...formFieldsPoojaBookingReport, location:""});
  };

  return (
    <div>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          <CustomInputLabel>Sign-In Name</CustomInputLabel>
          <CustomTextFeildforFamily
            fullWidth
            required
            value={formDataBookPoojaReport.signInName}
            onChange={(e) => {
              handleDropdownChange("signInName", e.target.value);
              setErrorMessageBookPoojaReport({
                ...errorMessageBookPoojaReport,
                signInName: "",
              });
            }}
            className={
              errorMessageBookPoojaReport.signInName
                ? styles.errorTextField
                : styles.dateFeild
            }
          />
          {errorMessageBookPoojaReport.signInName ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessageBookPoojaReport.signInName}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Location", false)}
          <CustomRadioButton
            checked={formDataBookPoojaReport.location === "TEMPLE_POOJA"}
            onChange={() => {
              handleDropdownChange("location", "TEMPLE_POOJA");
              setErrorMessageBookPoojaReport({
                ...errorMessageBookPoojaReport,
                location: "",
              });
            }}
            id="templeLocation"
          />
          <label className={styles.label}>Temple Pooja</label>
          <CustomRadioButton
            checked={formDataBookPoojaReport.location === "OUTSIDE_POOJA"}
            onChange={() => {
              handleDropdownChange("location", "OUTSIDE_POOJA");
              setErrorMessageBookPoojaReport({
                ...errorMessageBookPoojaReport,
                location: "",
              });
            }}
            id="outLocation"
          />
          <label className={styles.label}>Outside Pooja</label>
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Pooja", false)}
          {PoojaListDropdownDaily()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Receipt Date From", false)}
          {ReceiptDobDatePickerFrom()}
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Receipt Date To", false)}
          {ReceiptDobDatePickerTo()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Pooja  Date From", false)}
          {PoojaDobDatePickerFrom()}
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Pooja  Date To", false)}
          {PoojaDobDatePickerTo()}
        </Grid>
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitBookReport}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </div>
  );
};
export default PoojaBookingReport;
